<!-- ═════════════ FLOATING "ASK AI" BUTTON (bottom-right) ═════════════ -->
<button
  type="button"
  class="ai-fab no-print"
  [class.is-hidden]="open"
  (click)="toggle()"
  [attr.tabindex]="open ? -1 : 0"
  [attr.aria-expanded]="open"
  aria-haspopup="dialog"
  aria-controls="reportAssistant"
  title="Ask the report assistant"
>
  <span class="ai-fab__orb"
    ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.bot" /></svg
  ></span>
  <span class="ai-fab__label">Ask AI</span>
  <svg class="ic ai-fab__spark" viewBox="0 0 24 24"><path [attr.d]="icons.sparkle" /></svg>
</button>

<!-- ═════════════ AI ASSISTANT PANEL ═════════════ -->
<div class="ai-backdrop no-print" [class.is-open]="open" (click)="close()"></div>

<aside
  id="reportAssistant"
  class="ai no-print"
  [class.is-open]="open"
  role="dialog"
  aria-label="Report assistant"
  [attr.aria-hidden]="!open"
>
  <header class="ai__head">
    <div class="ai__avatar">
      <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.bot" /></svg>
      <i class="ai__online"></i>
    </div>
    <div class="ai__who">
      <strong>Report Assistant</strong>
      <span>Reads this report · replies instantly</span>
    </div>
    <button
      type="button"
      class="ai__icon-btn"
      (click)="clearChat()"
      *ngIf="messages.length"
      title="New chat"
    >
      <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.trash" /></svg>
    </button>
    <button type="button" class="ai__icon-btn" (click)="close()" title="Close (Esc)">
      <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.close" /></svg>
    </button>
  </header>

  <div class="ai__context">
    <span
      ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.parts" /></svg
      >{{ stats.partsInspected }} parts read</span
    >
    <span [class.is-warn]="stats.defectsCount"
      ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.defect" /></svg
      >{{ stats.defectsCount }} {{ stats.defectsCount === 1 ? 'defect' : 'defects' }}</span
    >
    <span
      ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.flag" /></svg
      >{{ stats.flagsCount }} {{ stats.flagsCount === 1 ? 'flag' : 'flags' }}</span
    >
  </div>

  <div class="ai__scroll" #chatScroll>
    <!-- welcome + suggestions -->
    <div class="ai__welcome" *ngIf="!messages.length">
      <div class="ai__orb">
        <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.sparkle" /></svg>
      </div>
      <h3>Ask me about this {{ brand }}</h3>
      <p>I've gone through the whole report. Pick a question or type your own.</p>

      <div class="ai__suggest">
        <button
          type="button"
          *ngFor="let s of suggestedQuestions; index as i"
          [style.--i]="i"
          (click)="ask(s.text)"
        >
          <span class="ai__suggest-ico"
            ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons[s.icon]" /></svg
          ></span>
          <span>{{ s.text }}</span>
        </button>
      </div>
    </div>

    <!-- conversation -->
    <div
      class="ai__msg"
      *ngFor="let m of messages; last as isLast"
      [ngClass]="'ai__msg--' + m.role"
    >
      <span class="ai__mini" *ngIf="m.role === 'bot'"
        ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.bot" /></svg
      ></span>
      <div class="ai__bubble">
        <p>{{ m.text }}</p>
        <ul *ngIf="m.bullets?.length">
          <li *ngFor="let b of m.bullets">{{ b }}</li>
        </ul>
        <div
          class="ai__follow"
          *ngIf="m.role === 'bot' && isLast && m.followUps?.length && !typing"
        >
          <button type="button" *ngFor="let f of m.followUps" (click)="ask(f)">
            <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.sparkle" /></svg>{{ f }}
          </button>
        </div>
      </div>
    </div>

    <div class="ai__msg ai__msg--bot" *ngIf="typing">
      <span class="ai__mini"
        ><svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.bot" /></svg
      ></span>
      <div class="ai__bubble ai__typing" aria-label="Assistant is typing">
        <i></i><i></i><i></i>
      </div>
    </div>
  </div>

  <footer class="ai__foot">
    <div class="ai__input">
      <input
        #chatInput
        type="text"
        [value]="draft"
        (input)="draft = $any($event.target).value"
        (keydown.enter)="sendDraft()"
        placeholder="Ask about price, defects, repairs…"
        autocomplete="off"
        [disabled]="typing"
      />
      <button
        type="button"
        (click)="sendDraft()"
        [disabled]="!draft.trim() || typing"
        aria-label="Send"
      >
        <svg class="ic" viewBox="0 0 24 24"><path [attr.d]="icons.send" /></svg>
      </button>
    </div>
    <small>Answers come only from this report. Always confirm key details in person.</small>
  </footer>
</aside>
